"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CategoryPageSkeleton = void 0;
var _editorialComponents = require("@ori/editorial-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _categoryPageClasses = require("../CategoryPage/categoryPageClasses");
var _styles = require("../LandingPage/styles");
var _styles2 = require("../LandingPageSkeleton/styles");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Renders Skeleton for `CategoryPage`.
 */ const CategoryPageSkeleton = (param)=>{
    let { animation = 'pulse', className } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        className: className,
        "data-testid": getTestId(_constants.CATEGORY_PAGE_SKELETON),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles2.TopBannerSkeleton, {
                animation: animation,
                className: _categoryPageClasses.categoryPageClasses.topBanner
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles2.DescriptionSkeleton, {
                animation: animation,
                className: _categoryPageClasses.categoryPageClasses.description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_editorialComponents.ArticlesSectionSkeleton, {
                animation: animation,
                mode: "listing",
                className: _categoryPageClasses.categoryPageClasses.articlesSection
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_editorialComponents.CategoriesSectionSkeleton, {
                animation: animation,
                className: _categoryPageClasses.categoryPageClasses.categoriesSection
            })
        ]
    });
};
exports.CategoryPageSkeleton = CategoryPageSkeleton;
